export default {
  STATUS_200: 200,
  STATUS_302: 302
}
